import { Box, Card, Inline, Stack, Text } from "@origin-digital/ods-core";
import React from "react";
import { sharedContent as content } from "./content.json";
import { IIBatterySizePrice } from "@/contract/generated/electrify-v1";
import GoodWe from "@/assets/goodwe.svg";
import { teslaBase64 } from "@/assets/tesla";
import { sungrowBase64 } from "@/assets/sungrow";
import { formatNumberWithCommas } from "@/utils";

export const BatteryDetails = ({
  batterySizePrice,
}: {
  batterySizePrice: IIBatterySizePrice;
}) => {
  const { minPrice, maxPrice } = batterySizePrice;

  return (
    <Box
      width="full"
      display="flex"
      marginRight={{ xs: "none", lg: "xsmall" }}
      marginBottom={{ xs: "medium", lg: "none" }}
    >
      <Card outline={true}>
        <Stack space={"large"}>
          <Stack space={"xsmall"}>
            <Text variant={"subtitle-small"}>
              {`$${formatNumberWithCommas(
                minPrice
              )} - $${formatNumberWithCommas(maxPrice)}`}
            </Text>
            <Stack space={"none"}>
              <Text variant={"body-small"}>
                {content.battery.accordion.rrpText}
              </Text>
              <Text variant={"body-small"}>
                {content.battery.accordion.excludingInstallationText}
              </Text>
            </Stack>
          </Stack>
          <Stack space={"xsmall"}>
            <Text tone={"neutralDark"}>
              {content.battery.accordion.logosText}
            </Text>
            <br />
            <Inline
              space={["small", "small"]}
              alignX="left"
              alignY="center"
              direction="row"
            >
              <GoodWe height="35px" />
              <Box padding="xsmall">
                <img
                  src={`data:image/png;base64,${teslaBase64}`}
                  alt="tesla"
                  width="93px"
                  height="31px"
                />
              </Box>
              <Box padding="xsmall">
                <img
                  src={`data:image/png;base64,${sungrowBase64}`}
                  alt="sungrow"
                  width="125px"
                  height="15px"
                />
              </Box>
            </Inline>
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
};
